<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/abnormalArrivalTrajectory";
export default {
  name: "abnormalArrivalTrajectory",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return this.selectAll.length === 0;
              },
            },
            {
              name: () => this.$tz("批量,完成"),
              type: "done",
              fnName: "done",
              bind: {
                type: "primary",
              },
              disabled() {
                return this.selectAll.length === 0;
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            done() {
              this.$Modal.confirm({
                title: this.$tz("批量,完成"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "complete",
                    { ids: this.selectAll.map((t) => t.id) },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center",
        },
        {
          name: () => this.$tz("订单号"),
          key: "airway_number",
          minWidth: 110,
        },
        {
          name: () => this.$tz("异常,轨迹"),
          key: "status",
          minWidth: 110,
        },
        {
          name: () => this.$tz("记录,时间"),
          key: "create_time",
          minWidth: 110,
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>